import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
//import {SharedModule} from '../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { CommonModule } from '@angular/common';
//import { SpinnerComponent } from '../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { NbTabsetModule } from '@nebular/theme';
@Component({
    selector: 'app-reparaciones-ayuda-popup',
    templateUrl: './reparaciones-ayuda-popup.component.html',
    styleUrls: ['./reparaciones-ayuda-popup.component.css'],
    standalone: true,
    imports: [FormsModule,CommonModule,NbCardModule,NbIconModule,DropdownModule,MatCardModule,MatFormFieldModule,MatInputModule,AngularSlickgridModule,NbTabsetModule],
})
export class ReparacionesAyudaPopupComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ReparacionesAyudaPopupComponent>) { }

  ngOnInit(): void {
  }
  close(){
    this.dialogRef.close();
  }

}
